<template>
    <div class="wrap-range-slider px-4 my-3">
        <div class="col-view"><p>{{ mealsCount }}</p><span>Meals</span></div>
        <div class="col-input">
            <h4 class="mb-2">Add {{  allmeals }} more meals to <span>save {{ discount }}%</span></h4>         
            <div>
                <v-slider
                    v-model="mealsCount"
                    :max="discountMaximumDish"
                    :min="0"
                    :step="1"                
                    hide-details
                    color="rgba(104, 91, 199, 1)"
                    track-color="rgba(225, 230, 239, 1)"
                    track-size="11"           
                    name="range-slider"
                    thumb-size="24"         
                >                   
                </v-slider>
            </div>
        </div>        
    </div>
</template>

<script>
import { VSlider } from 'vuetify/lib/components/VSlider/VSlider.mjs'

export default {
    name: 'rangeSlider',
    components: {
        VSlider,
    },
    data() {
        return {
        };
    },
    computed: {
        menus() {
            return this.$store.getters.getMenus;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        orderProducts() {
            return this.$store.getters.orderProducts;
        },
        mealsCount() {
            let count = 0;
            let data = [...this.orderProducts.mainProducts, ...this.orderProducts.breakfastProducts, ...this.orderProducts.snacksProducts];
       
            if(data.length > 0 && this.wizardMenu[5].isActive == true) {
                data.forEach(function(product) {
                    count += Number(product.count);
            
                });
           
            } else {
                count = (Number(this.menus[0].count) + Number(this.menus[1].count) + Number(this.menus[2].count)) * Number(this.itemsOrder.days)
            }
            
            return count;  
        },
        discountMaximumDish() {
            return (this.$store.getters.discountMaximum / this.$store.getters.discount) * this.$store.getters.allmeals;
        },
        allmeals() {
            if(this.mealsCount == 0) {
                return this.$store.getters.allmeals ?? 15;
            } else if( this.mealsCount >= this.discountMaximumDish) {
                return 0;
            } else {
                return this.$store.getters.allmeals - this.mealsCount % this.$store.getters.allmeals;
            }
        },
        discountMax() {
            return this.$store.getters.discountMaximum;
        },
        discountMin() {
          
             return this.$store.getters.discountMin;
        },
        discounStep() {
  
            return this.$store.getters.discountMin;
        },
        discount() {  
               
           let discount = 0;

            if(this.mealsCount && this.$store.getters.allmeals ) {
                discount = this.$store.getters.discount * Math.floor(this.mealsCount / this.$store.getters.allmeals);
            }

            if(discount > this.discountMax) { 
                discount = this.discountMax
                this.setDiscount(discount);            
                return discount;
            }

            if (discount < this.discountMin && this.mealsCount > 0) {
                discount = this.discountMin
            } else if (this.mealsCount == 0) {
                discount = 0
            }
            
            this.setDiscount(discount);
            
            return discount;
        },
    },
    methods: {
        setDiscount(discount) {
            this.itemsOrder.discount = discount;
        }
    }
}
</script>

<style scoped  lang="stylus">
.wrap-range-slider {
    display: flex;
    align-content: center;
    margin: auto;
    flex-wrap: wrap;
    justify-content: center;
    .col-view {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 70px;
        height: 70px;
        background: #FFFFFF;
        border: 2px solid #685BC7;
        border-radius: 10px;
        p {
            font-family: sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 39px;
            line-height: .9;
            text-align: center;
            color: #685BC7;
        }
        span {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 1;
            text-align: center;
            color: #685BC7;
            
            @media screen and (max-width: 767px) {
                font-size: 12px;
            }
        }
    }
    .col-input {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 20px;
        min-width: 262px;

        @media (max-width: 393px) {
            margin-top: 1rem;
        }
        h4 {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }

            span {
                font-family: 'Manrope', sans-serif;
                font-weight: 800;
                font-size: 16px;
                line-height: 22px;
                color: #685BC7;
            }
        }
        input[type=range]  {
            width: 200px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            outline: none;
            overflow: hidden;
            height: 7px;
        }

         input[type=range]::-webkit-slider-runnable-track {
            height: 7px;
            background-color: blue;
        }

        input[type=range]::-webkit-slider-thumb {
            background: #ecf0f1;
            cursor: pointer;
            width:15px;
            height: 15px;
            -webkit-appearance: none;
            margin-top: -4px;
            box-shadow: -200px  0 0 200px  #43e5f7;

        }

        input[type=range]::-moz-range-track {
            height: 7px;
            background-color: blue;
        }

        input[type=range]::-moz-range-thumb {
            background: #ecf0f1;
            cursor: pointer;
            height: 7px;
            border-radius:0px;
            box-shadow: -200px  0px 0px 200px   #43e5f7;
            padding: 0px;
            margin: 0px;
        }
    }
}
</style>